/**
 * Control getting heatmap data
 * @param heatMapLayer  an instance of the HeatMapLayer class
 */
define(['jquery'], function ($) {
   "use strict";

   return function (heatMapLayer) {
      var self = this,
         BingMaps = window.Microsoft.Maps,

         m_xhr,
         formatPrice = function (nStr) {
            nStr = Math.round(nStr).toString();
            var x = nStr.split('.'),
               x1 = x[0],
               x2 = x.length > 1 ? '.' + x[1] : '',
               rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
               x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return '$' + x1 + x2;
         },
         addData = function (data, strMeta) {
            heatMapLayer.clearHeatMap();

            // For each location
            $.each(data.locations, function (strLocationName, loc) {
               // For each polygon
               $.each(loc.polygons, function (i, polygon) {
                  // This would be the pretty way of doing it
                  var aPoints = polygon.split("|"),
                     aLocation = [],
                     meta = (loc.meta) ? loc.meta[strMeta] : null;

                  // For each set of points
                  $.each(aPoints, function (i, strPoint) {
                     var aPointParts = strPoint.split(","),
                        strLatitude = aPointParts[1],
                        strLongitude = aPointParts[0],
                        fLatitude = parseFloat(strLatitude),
                        fLongitude = parseFloat(strLongitude),
                        loc = new BingMaps.Location(fLatitude, fLongitude);

                     aLocation.push(loc);
                  });
                  if (meta) {
                     // TODO this shouldn't be set for every row
                     var scaleStart = 0,
                        scaleEnd = 100,
                        scaleLabel = meta,
                        scaleStartStr = "",
                        scaleEndStr = "";
                     switch (strMeta) {
                     case 'totalPopulation':
                        scaleStart = 100;
                        scaleEnd = 100000;
                        scaleLabel = meta.toFixed() ;
                        scaleStartStr = "< 100";
                        scaleEndStr = "100000+";
                        break;
                     case 'medianIncome':
                        scaleStart = 10000;
                        scaleEnd = 200000;
                        scaleStartStr = "< $10K";
                        scaleEndStr = "$200K+";
                        scaleLabel = formatPrice(meta);
                        break;
                     case 'medianHomePrice':
                        scaleStart = 10000;
                        scaleEnd = 1000000;
                        scaleStartStr = "< $10K";
                        scaleEndStr = "$1000K+";
                        scaleLabel = formatPrice(meta);
                        break;
                     }
                     $(".heatMapLegend").show();
                     $("#legendLowRange").text(scaleStartStr);
                     $("#legendHighRange").text(scaleEndStr);
                     // Example of adding to the heatmap by age, passing in the min and max
                     var label = loc.meta.name + ", " + strLocationName + "<br>" + scaleLabel;
                     heatMapLayer.addMapLocation(aLocation, meta, scaleStart, scaleEnd, label);
                  }
               });
            });
         };

      self.getData = function (bounds, options) {
         m_xhr = $.ajax({
            dataType: "json",
            data: {
               xy: bounds.xy,
               mx: bounds.mx,
               my: bounds.my,
               xx: bounds.xx,
               zoom: bounds.zoom,
               submitted: true,
               subView: "HeatMapSearch"
            },
            url: "/heatmap/?",
            success: function (data) {
               addData(data, options.meta);

               if (options.success) {
                  options.success();
               }
            },
            error: options.error
         });
      };

      self.cancel = function () {
         if (m_xhr) {
            m_xhr.abort();
         }
      };
   };
});
